<template>
  <div class="wrapper">
    <div class="banner" />
    <div class="blue-box">
      <h1 class="text-uppercase --white --bigger">
        {{ $t('pages.company-home.hero.title') }}
      </h1>
      <!-- eslint-disable-next-line -->
      <h1 class="--white" v-html="$t('pages.company-home.hero.subtitle', { portal: appName })">
      </h1>
      <b-button
        class="light-button"
        @click="$router.push({ name: 'publish-offer' })"
      >
        {{ $t('pages.company-home.hero.button') }}
      </b-button>
    </div>
    <div class="second">
      <b-container>
        <h1
          data-aos="zoom-in"
          class="text-uppercase --gray mt-5"
        >
          {{ $t('pages.company-home.sections.publish-offer.title') }}
        </h1>
        <div
          class="hr"
          style="background-color: #00AFEF !important;"
        />
      </b-container>
      <b-container class="fix-cont">
        <b-row>
          <b-col
            class="white-block"
            lg="4"
            data-aos="zoom-out-right"
            data-aos-delay="500"
          >
            <div>
              <img
                src="../assets/company-home/pc-icon.png"
                alt=""
                style="width: 100px;"
              >
            </div>
            <h2>{{ $t('pages.company-home.sections.publish-offer.publish-card.title') }}</h2>
            <!-- <p>{{ $t('pages.company-home.sections.publish-offer.publish-card.subtitle') }}</p> -->
          </b-col>
          <b-col
            id="middle"
            class="white-block"
            lg="4"
            data-aos="zoom-out-right"
            data-aos-delay="400"
          >
            <div>
              <img
                src="../assets/company-home/spot-icon.png"
                alt=""
                style="width: 110px; margin-top: 10px"
              >
            </div>
            <h2>{{ $t('pages.company-home.sections.publish-offer.receive-card.title') }}</h2>
            <!-- <p>{{ $t('pages.company-home.sections.publish-offer.receive-card.subtitle') }}</p> -->
          </b-col>
          <b-col
            class="white-block"
            lg="4"
            data-aos="zoom-out"
            data-aos-delay="300"
          >
            <div>
              <img
                src="../assets/company-home/search-icon.png"
                alt=""
                style="width: 130px; margin-top: 10px"
              >
            </div>
            <h2>{{ $t('pages.company-home.sections.publish-offer.select-card.title') }}</h2>
            <!-- <p>{{ $t('pages.company-home.sections.publish-offer.select-card.subtitle') }}</p> -->
          </b-col>
        </b-row>
      </b-container>
      <b-button
        class="button-4"
        style="text-align: center !important;"
        @click="$router.push({ name: 'publish-offer' })"
      >
        {{ $t('pages.company-home.sections.publish-offer.button') }}
      </b-button>
    </div>
    <div class="third">
      <b-container>
        <h1
          data-aos="zoom-in"
          class="--white pt-5"
        >
          {{ $t('pages.company-home.sections.find-talent.title') }}
        </h1>
        <div
          class="hr"
          style="background-color: #00AFEF !important;"
        />
      </b-container>
      <b-container class="fix-cont">
        <b-row>
          <b-col
            class="white-block"
            lg="4"
            data-aos="zoom-out-right"
            data-aos-delay="500"
          >
            <div>
              <img
                src="../assets/company-home/bag-icon.png"
                alt=""
                style="width: 100px;"
              >
            </div>
            <h2>
              {{ $t('pages.company-home.sections.find-talent.findcv-card.title') }}
            </h2>
            <!-- <p>{{ $t('pages.company-home.sections.find-talent.findcv-card.subtitle') }}</p> -->
          </b-col>
          <b-col
            id="middle"
            class="white-block"
            lg="4"
            data-aos="zoom-out-right"
            data-aos-delay="400"
          >
            <div>
              <img
                src="../assets/company-home/connection-icon.png"
                alt=""
                style="width: 110px; margin-top: 10px"
              >
            </div>
            <h2>
              {{ $t('pages.company-home.sections.find-talent.interest-card.title') }}
            </h2>
            <p>
              <!-- {{ $t('pages.company-home.sections.find-talent.interest-card.subtitle') }} -->
            </p>
          </b-col>
          <b-col
            class="white-block"
            lg="4"
            data-aos="zoom-out"
            data-aos-delay="300"
          >
            <div>
              <img
                src="../assets/company-home/bag-open-icon.png"
                alt=""
                style="width: 130px; margin-top: 10px"
              >
            </div>
            <h2>
              {{ $t('pages.company-home.sections.find-talent.payment-card.title') }}
            </h2>
            <p>
              <!-- {{ $t('pages.company-home.sections.find-talent.payment-card.subtitle') }} -->
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-button
        class="button-4"
        style="text-align: center !important;"
        @click="$router.push({ name: 'publish-offer' })"
      >
        {{ $t('pages.company-home.sections.find-talent.button') }}
      </b-button>
    </div>
    <div class="skew-white" />
    <div class="fourth">
      <h1>{{ $t('pages.company-home.sections.partners.title', { portal: appName }) }}</h1>
      <div class="clients">
        <hr>
        <div class="sliding-bg-wrapper">
          <div class="sliding-background" />
        </div>
      </div>
    </div>
    <div class="skew-white-rev" />
    <div class="fifth">
      <h1 class="--white">
        {{ $t('pages.company-home.sections.selection.title') }}
      </h1>
      <div class="hr-left" />
      <p>{{ $t('pages.company-home.sections.selection.subtitle') }}</p>
    </div>
    <div class="sixth">
      <h1 class="--white pt-5">
        {{ $t('pages.company-home.sections.candidate.title') }}
      </h1>
      <b-button
        class="light-button mb-5"
        @click="$router.push({ name: 'publish-offer' })"
      >
        {{ $t('pages.company-home.sections.candidate.button') }}
      </b-button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "CompanyHome",
        computed: {
          appName() {
            return process.env.VUE_APP_NAME;
          }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        overflow: hidden;
        .skew-white {
            width: 100%;
            height: 100px;
            /*position: absolute;*/
            left: 0px;
            margin-top: -100px;
            background: linear-gradient(to right bottom, transparent 49%, white 50%);
        }
        .skew-white-rev {
            width: 100%;
            height: 100px;
            position: relative;
            margin-bottom: -100px;
            left: 0px;
            //margin-top: -100px;
            background: linear-gradient(to right bottom, white 49%, transparent 50%);
        }
        .light-button{
            margin-top: 20px;
            border-radius: 40px;
            font-family: LatoWebMedium, sans-serif;
            letter-spacing: 2px;
            background-color: #00AFEF;
            &:hover{
                background-color: #00BFFF;
            }
        }
        .dark-button{
            margin-top: 20px;
            border-radius: 40px;
            font-family: LatoWebMedium, sans-serif;
            letter-spacing: 2px;
            background-color: #0070A9;
            &:hover{
                background-color: #0080B9;
            }
        }
        .banner{
            background-image: url("../assets/company-home/jobs-banner.jpg");
            background-repeat: no-repeat;
            padding-bottom: 500px;
            background-position: center;
            background-size: cover;
            @media only screen and (max-width: 600px) {
                background-position: left;
                margin-top: -120px;
                background-size: 300%;
            }
        }
        .blue-box{
            position: relative;
            margin: -200px auto auto auto;
            border-radius: 40px;
            background-color: rgba(74,159,220,0.5);
            padding: 30px;
            width: 50%;
            min-width: 314px;
        }
        .first{
            text-align: center;
        }
        .second {
            /*background: rgb(0, 238, 204);*/
            /*background: linear-gradient(48deg, rgba(0, 238, 204, 1) 15%, rgba(0, 110, 175, 1) 100%);*/
            text-align: center;
            .fix-cont {
                min-width: 50%;
                max-width: 70%;
            }

            #middle{
                position: relative;
                z-index: 1000;
                -webkit-box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
                -moz-box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
                box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
            }

            .white-block {
                position: relative;
                z-index: 50;
                margin-top: 50px;
                margin-bottom: 50px;
                border-radius: 80px;
                background-color: whitesmoke;
                padding: 30px;
                @media only screen and (max-width: 600px) {
                    padding: 20px;
                }

                p {
                    font-family: LatoWebMedium, sans-serif;
                    color: #c7c7c7;
                }

                img {
                    margin-bottom: 50px;
                }
                transition: 0.3s;
                &:hover{
                    border-radius: 100px;
                    background-color: white;
                    cursor: pointer;
                    transform: scale(1.2);
                    z-index: 51;
                }
            }
            .button-4 {
                background-color: #0070A9;
                border-radius: 20px;
                padding: 5px 20px 5px 20px;
                position: relative;
                font-size: 1rem;
                letter-spacing: 3px;
                margin-bottom: 50px;
                &:hover {
                    background-color: #00C5C3;
                }
            }
        }
        .third {
            padding-bottom: 50px;
            background: rgb(0, 238, 204);
            background: linear-gradient(48deg, rgba(0, 238, 204, 1) 15%, rgba(0, 110, 175, 1) 100%);
            text-align: center;
            .fix-cont {
                min-width: 50%;
                max-width: 70%;
            }

            #middle{
                position: relative;
                z-index: 1000;
                -webkit-box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
                -moz-box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
                box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.75);
            }

            .white-block {
                position: relative;
                z-index: 50;
                margin-top: 50px;
                margin-bottom: 50px;
                border-radius: 80px;
                background-color: whitesmoke;
                padding: 20px;

                h2 {
                  font-size: 1.2rem !important;
                }

                @media only screen and (max-width: 600px) {
                    padding: 20px;
                }

                p {
                    font-family: LatoWebMedium, sans-serif;
                    color: #c7c7c7;
                }

                img {
                    margin-bottom: 50px;
                }
                transition: 0.3s;
                &:hover{
                    border-radius: 100px;
                    background-color: white;
                    cursor: pointer;
                    transform: scale(1.2);
                    z-index: 51;
                }
            }
            .button-4 {
                background-color: #0070A9;
                border-radius: 20px;
                padding: 5px 20px 5px 20px;
                position: relative;
                font-size: 1rem;
                letter-spacing: 3px;
                margin-bottom: 50px;
                &:hover {
                    background-color: #00C5C3;
                }
            }
        }
        .fifth{
            padding-top: 100px;
            padding-left: 150px;
            padding-right: 150px;
            background-image: url("../assets/company-home/Aicad-Jobs-LP.jpg");
            background-repeat: no-repeat;
            padding-bottom: 500px;
            background-position: right;
            background-size: cover;
            text-align: left;
            @media only screen and (max-width: 600px) {
                padding-left: 20px;
                padding-right: 20px;
            }
            p{
                max-width: 350px;
                margin-top: 20px;
                color: white;
            }
        }
        .sixth{
            background: rgb(0,207,194);
            background: linear-gradient(90deg, rgba(0,207,194,1) 0%, rgba(0,109,170,1) 100%);
        }
        .hr-left {
            background-color: white;
            height: 2px;
            width: 450px;
            position: relative;
            text-align: left;
            /*left: 30%;*/
        }
        .hr {
            background-color: #0070A9;
            height: 2px;
            width: 450px;
            position: relative;
            text-align: center;
            left: 30%;
        }
        /* SLIDING BG */
        .sliding-bg-wrapper {
            overflow: hidden;
        }

        .sliding-background {
            background: url("../assets/company-home/clients-bg.jpg") repeat-x;
            height: 100px;
            width: 9216px;
            animation: slide 60s linear infinite;
        }

        .sliding-background:hover {
            animation-play-state: paused;
        }

        @keyframes slide{
            0%{
                transform: translate3d(0, 0, 0);
            }
            100%{
                transform: translate3d(-3072px, 0, 0);
            }
        }
        /*  */


    }
</style>